"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StatusChip;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["disabled", "strong", "notification", "warning", "error", "success"];
var useStyles = (0, _makeStyles.default)(function () {
  return {
    disabled: {
      backgroundColor: '#0000001F !important',
      color: '#00000061 !important'
    },
    error: function error(_ref) {
      var strong = _ref.strong;
      return strong ? {
        backgroundColor: '#AF2244',
        color: '#FFFFFF'
      } : {
        backgroundColor: '#ED1B2F1F',
        color: '#ED1B2F'
      };
    },
    indicator: {
      alignItems: 'center',
      display: 'flex'
    },
    notification: function notification(_ref2) {
      var strong = _ref2.strong;
      return strong ? {
        backgroundColor: '#0077C8',
        color: '#FFFFFF'
      } : {
        backgroundColor: '#0077C81F',
        color: '#0077C8'
      };
    },
    success: {
      backgroundColor: '#007B00',
      color: '#FFFFFF'
    },
    warning: {
      backgroundColor: '#FF98001F',
      color: '#FF9800'
    }
  };
});
function StatusChip(_ref3) {
  var disabled = _ref3.disabled,
    strong = _ref3.strong,
    notification = _ref3.notification,
    warning = _ref3.warning,
    error = _ref3.error,
    success = _ref3.success,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  var classes = useStyles({
    strong
  });
  return /*#__PURE__*/_react.default.createElement(_material.Chip, (0, _extends2.default)({
    className: (0, _classnames.default)({
      [classes.success]: success,
      [classes.notification]: notification,
      [classes.warning]: warning,
      [classes.error]: error,
      [classes.disabled]: disabled
    })
  }, props, {
    size: "small"
  }));
}